__turbopack_context__.v({
  "card": "_8tflDW_card",
  "cardsContainer": "_8tflDW_cardsContainer",
  "modalContent": "_8tflDW_modalContent",
  "root": "_8tflDW_root",
});
